import React from 'react';
import { Ship, Plane, Truck, Package, FileText, Container } from 'lucide-react';
import './ServiceHighlight.css';

const ServiceHighlight: React.FC = () => {
  const services = [
    { icon: <Ship size={24} />, name: 'Freight Forwarding' },
    { icon: <Plane size={24} />, name: 'Air Cargo Services' },
    { icon: <Container size={24} />, name: 'Import & Export' },
    { icon: <FileText size={24} />, name: 'Custom Clearance' },
    { icon: <Truck size={24} />, name: 'Haulage Services' },
    { icon: <Package size={24} />, name: 'Cargo Logistics' }
  ];

  return (
    <section className="service-highlight">
      <div className="service-highlight-container">
        <div className="service-highlight-image">
          <img 
            src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1200&q=80" 
            alt="CN Terminal Logistics Services" 
            className="highlight-image"
          />
        </div>
        <div className="service-highlight-content">
          <div className="service-menu">
            <div className="service-menu-header">
              <span>Services to Ghana</span>
            </div>
            <ul className="service-menu-list">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="service-icon">{service.icon}</span>
                  <span>{service.name}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="service-text">
            <h2 className="service-title">End-to-End Logistics Services</h2>
            <div className="service-paragraphs">
              <p>
                As a licensed Customs House Agency, CN Terminal provides comprehensive door-to-door 
                freight services connecting businesses worldwide to Ghana. Our expertise in sea freight 
                forms the core of our operations, ensuring reliable and cost-effective shipping solutions. 
                We collect cargo from anywhere and deliver everywhere in Ghana with precision and care.
              </p>
              <p>
                Our dedicated team of drivers, warehouse managers, and logistics professionals are 
                committed to transporting and handling your goods efficiently and safely. We train all 
                our employees to ensure seamless transfers, minimizing transit time while maintaining the 
                highest standards of safety and security for your shipments. You can trust that your goods 
                will reach their intended destination in perfect condition!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlight;

